'use strict';

(function () {

  function initToolboxLogic() {
    var mountTypeHidden = document.getElementById('toolbox-mount-type');
    var toolboxFields   = document.getElementById('toolbox-fields');
    var toolboxBanner   = document.getElementById('fitment-banner-toolbox');
    var toolboxReviewFlag = document.getElementById('toolbox-review-flag');
    var mountCards      = document.querySelectorAll('.fitment-mount-type__card');

    if (!mountTypeHidden || !toolboxFields || !mountCards.length) return;

    var _savedNames = {};

    function stripNames() {
      toolboxFields.querySelectorAll('input[name^="properties"], textarea[name^="properties"]').forEach(function (el) {
        _savedNames[el.id || el.name] = el.getAttribute('name');
        el.removeAttribute('name');
      });
    }

    function restoreNames() {
      toolboxFields.querySelectorAll('input, textarea').forEach(function (el) {
        var key = el.id || el.name;
        if (key && _savedNames[key]) {
          el.setAttribute('name', _savedNames[key]);
        }
      });
    }

    function syncRequiredAttrs(enabled) {
      toolboxFields.querySelectorAll('input[type="number"], input[type="text"]').forEach(function (el) {
        if (enabled) {
          el.setAttribute('required', '');
          el.setAttribute('aria-required', 'true');
        } else {
          el.removeAttribute('required');
          el.removeAttribute('aria-required');
          el.value = '';
        }
      });
      var textarea = toolboxFields.querySelector('textarea');
      if (textarea && !enabled) textarea.value = '';
    }

    function applySelection(selectedValue) {
      mountTypeHidden.value = selectedValue;
      mountCards.forEach(function (card) {
        if (card.dataset.mountValue === selectedValue) {
          card.classList.add('fitment-mount-type__card--selected');
        } else {
          card.classList.remove('fitment-mount-type__card--selected');
        }
      });
      var isToolbox = selectedValue === 'Tool Box Mounted';
      if (toolboxReviewFlag) toolboxReviewFlag.value = isToolbox ? 'true' : 'false';
      if (isToolbox) {
        toolboxFields.classList.add('visible');
        restoreNames();
        syncRequiredAttrs(true);
        if (toolboxBanner) { toolboxBanner.removeAttribute('hidden'); toolboxBanner.classList.add('visible'); }
      } else {
        toolboxFields.classList.remove('visible');
        syncRequiredAttrs(false);
        stripNames();
        if (toolboxBanner) { toolboxBanner.setAttribute('hidden', ''); toolboxBanner.classList.remove('visible'); }
      }
    }

    mountCards.forEach(function (card) {
      card.addEventListener('click', function () {
        applySelection(card.dataset.mountValue);
      });
    });

    // Initial state: if Truck Bed Mounted is default, strip names immediately
    var defaultValue = mountTypeHidden.value;
    if (defaultValue !== 'Tool Box Mounted') {
      syncRequiredAttrs(false);
      stripNames();
    }
  }

  document.addEventListener('DOMContentLoaded', initToolboxLogic);
  document.addEventListener('quick-view:open', initToolboxLogic);

})();
